import { z } from 'zod';
export const KpiPeriodSchema = z.enum(['today', 'week', 'month']);
export const AgentKpiSchema = z.object({
    agentId: z.number().int(),
    agentName: z.string(),
    period: KpiPeriodSchema,
    callsTotal: z.number().int(),
    callsAnswered: z.number().int(),
    callsNoAnswer: z.number().int(),
    whatsappSent: z.number().int(),
    noteAdded: z.number().int(),
    contactRate: z.number(), // 0-1
    stageDistribution: z.record(z.number().int()),
    topBuildings: z.array(z.object({
        building: z.string().nullable(),
        count: z.number().int(),
    })),
});
export const TeamKpiSchema = z.object({
    managerId: z.number().int().nullable(),
    period: KpiPeriodSchema,
    totalCalls: z.number().int(),
    totalLandlordsWorked: z.number().int(),
    agents: z.array(z.object({
        agentId: z.number().int(),
        agentName: z.string(),
        calls: z.number().int(),
        landlordsWorked: z.number().int(),
    })),
    areaCoverage: z.array(z.object({
        areaId: z.number().int(),
        areaName: z.string(),
        count: z.number().int(),
    })),
});
export const SystemKpiSchema = z.object({
    period: KpiPeriodSchema,
    totalEvents: z.number().int(),
    totalCalls: z.number().int(),
    totalWhatsapp: z.number().int(),
    totalNotes: z.number().int(),
    totalStageChanges: z.number().int(),
    activeAgents: z.number().int(),
    landlordsCovered: z.number().int(),
    topAgents: z.array(z.object({
        agentId: z.number().int(),
        agentName: z.string(),
        eventCount: z.number().int(),
    })),
});
//# sourceMappingURL=kpi.js.map